import { render, staticRenderFns } from "./Colortable.vue?vue&type=template&id=e36563b2&scoped=true&"
import script from "./Colortable.vue?vue&type=script&lang=js&"
export * from "./Colortable.vue?vue&type=script&lang=js&"
import style0 from "./Colortable.vue?vue&type=style&index=0&id=e36563b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36563b2",
  null
  
)

export default component.exports